import React, { Component } from 'react'
import F from '../../../SPRINTA/Footer'
import T from '../../../SPRINTA/translate/T'


class Footer extends Component {

    render() {
        let lang = T.getLanguage()
        return (
            <F
                lang={lang}
                handleLangChanged={lang => {
                    T.setLanguage(lang)
                }}
                />
        )
    }
}

export default Footer
  


// WEBPACK FOOTER //
// ./src/components/organisms/Footer/index.js